<template>
  <div class="news-page">
    <Header modeType="1" />
    <div class="news-container">
      <h1 class="page-title">新闻中心</h1>
      <div class="news-list">
        <div
          v-for="(item, index) in newsList"
          :key="index"
          class="news-item"
          @click="jumpDetail(item.infoNo)"
        >
          <div class="news-left">
            <h3 class="news-title">{{ item.title }}</h3>
            <div class="news-date">{{ item.createTime }}</div>
            <p class="news-desc">{{ item.content }}</p>
          </div>
          <div class="news-right">
            <img :src="item.coverUrl" alt="新闻图片" />
          </div>
        </div>
      </div>
      <div class="pagination">
        <a-pagination
          v-model="pageNum"
          :default-page-size="pageSize"
          :total="total"
          :show-total="total => `共${total}条`"
          show-less-items
          show-quick-jumper
          @change="onChange"
        />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { getOfficialWebsiteInfomationList } from '@/apis/news';
import metaInfo from "@/common/util/metaInfo";
import { stripHtml } from '@/common/util/html';

export default {
  name: 'NewsIndex',
  metaInfo: metaInfo.news,
  components: {
    Header,
    Footer
  },
  data() {
    return {
      newsList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  mounted() {
    this.getDynamicList();
  },
  methods: {
    jumpDetail(id) {
      this.$router.push({ path: '/news/detail/' + id });
    },
    getDynamicList() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      getOfficialWebsiteInfomationList(params)
        .then(res => {
          const { rows } = res;
          rows.forEach(item => {
            item.title = stripHtml(item.title);
            item.content = stripHtml(item.content);
          });
          this.newsList = res.rows;
          this.total = res.total;
        })
        .catch(err => {
          console.log('新闻列表加载失败，使用模拟数据', err);
          // 临时使用模拟数据
          this.newsList = [
            {
              infoNo: '1',
              title: '汇通数科荣获"2023年度数字服务创新企业"称号',
              createTime: '2024-01-15',
              content: '汇通数科凭借在数字化服务领域的卓越贡献和创新实践，荣获"2023年度数字服务创新企业"称号。这是业界对汇通数科多年来致力于推动企业数字化转型的认可和肯定。',
              coverUrl: require('@/assets/home/industry/bg1.jpg')
            },
            {
              infoNo: '2',
              title: '汇通数科发布全新AI智能体平台',
              createTime: '2024-01-10',
              content: '汇通数科正式发布基于大模型的多智能体协作平台，为企业提供更智能、更高效的AI解决方案。该平台支持智能体编排、分布式协作和自主决策等核心能力。',
              coverUrl: require('@/assets/home/industry/bg2.jpg')
            },
            {
              infoNo: '3',
              title: '汇通数科与多家企业达成战略合作',
              createTime: '2024-01-05',
              content: '汇通数科近日与多家行业领军企业签署战略合作协议，共同推动产业数字化升级。各方将在AI应用、云服务、机器人等领域展开深度合作。',
              coverUrl: require('@/assets/home/industry/bg3.jpg')
            }
          ];
          this.total = 3;
        });
    },
    onChange(page) {
      this.pageNum = page;
      this.getDynamicList();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
};
</script>

<style lang="less" scoped>
.news-page {
  width: 100%;
  min-height: 100vh;
  background: #F8F9FA;
  padding: 60px 0;
}

.news-container {
  width: 1200px;
  margin: 0 auto;
}

.page-title {
  font-size: 36px;
  font-weight: 600;
  color: #222222;
  margin-bottom: 40px;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.news-item {
  display: flex;
  justify-content: space-between;
  padding: 30px;
  background: #FFFFFF;
  border-radius: 12px;
  cursor: pointer;
  transition: box-shadow 0.3s;
}

.news-item:hover {
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.08);
}

.news-left {
  flex: 1;
  padding-right: 40px;
}

.news-title {
  font-size: 24px;
  font-weight: 600;
  color: #222222;
  margin-bottom: 12px;
  line-height: 32px;
}

.news-date {
  font-size: 14px;
  color: #8B8FA1;
  margin-bottom: 16px;
}

.news-desc {
  font-size: 14px;
  color: #595959;
  line-height: 22px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.news-right {
  flex-shrink: 0;
}

.news-right img {
  width: 400px;
  height: 240px;
  object-fit: cover;
  border-radius: 8px;
}

.pagination {
  margin-top: 40px;
  text-align: right;
}
</style>
